import auth from '../api/auth'
import session from '../api/session'
import {
  LOGIN_BEGIN,
  LOGIN_FAILURE,
  LOGIN_SUCCESS,
  LOGOUT,
  REMOVE_TOKEN,
  SET_TOKEN,
  SET_ACCOUNT_DETAILS
} from './types'

const TOKEN_STORAGE_KEY = 'TOKEN_STORAGE_KEY'
const ACCOUNT_DETAILS_STORAGE_KEY = 'ACCOUNT_DETAILS_STORAGE_KEY'

const initialState = {
  authenticating: false,
  error: false,
  token: null,
  accountdetails: null
}

const getters = {
  isAuthenticated: state => !!state.token,
  accountdetails: state => state.accountdetails
}

const actions = {
  login ({ commit }, { username, password }) {
    commit(LOGIN_BEGIN)
    return auth.login(username, password)
      .then(({ data }) => commit(SET_TOKEN, data.key))
      .then(() => commit(LOGIN_SUCCESS))
      .catch(function (error) {
        commit(LOGIN_FAILURE)
        throw error
      })
  },
  logout ({ commit }) {
    return auth.logout()
      .then(() => commit(LOGOUT))
      .finally(() => commit(REMOVE_TOKEN))
  },
  getAccountDetails ({ commit }) {
    return auth.getAccountDetails()
      .then(({ data }) => commit(SET_ACCOUNT_DETAILS, data))
  },
  initialize ({ commit }) {
    const token = localStorage.getItem(TOKEN_STORAGE_KEY)
    const accountdetails = JSON.parse(localStorage.getItem(ACCOUNT_DETAILS_STORAGE_KEY))

    if (token) {
      commit(SET_TOKEN, token)
    } else {
      commit(REMOVE_TOKEN)
    }

    if (accountdetails) {
      commit(SET_ACCOUNT_DETAILS, accountdetails)
    }
  }
}

const mutations = {
  [LOGIN_BEGIN] (state) {
    state.authenticating = true
    state.error = false
  },
  [LOGIN_FAILURE] (state) {
    state.authenticating = false
    state.error = true
  },
  [LOGIN_SUCCESS] (state) {
    state.authenticating = false
    state.error = false
  },
  [LOGOUT] (state) {
    state.authenticating = false
    state.error = false
  },
  [SET_TOKEN] (state, token) {
    localStorage.setItem(TOKEN_STORAGE_KEY, token)
    session.defaults.headers.Authorization = `Token ${token}`
    state.token = token
  },
  [SET_ACCOUNT_DETAILS] (state, accountdetails) {
    localStorage.setItem(ACCOUNT_DETAILS_STORAGE_KEY, JSON.stringify(accountdetails))
    state.accountdetails = accountdetails
  },
  [REMOVE_TOKEN] (state) {
    localStorage.removeItem(TOKEN_STORAGE_KEY)
    delete session.defaults.headers.Authorization
    state.token = null
  }
}

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/auth.js